import { render, staticRenderFns } from "./ChooseLanguage.vue?vue&type=template&id=c44a733a&scoped=true&"
import script from "./ChooseLanguage.vue?vue&type=script&lang=js&"
export * from "./ChooseLanguage.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLanguage.vue?vue&type=style&index=0&id=c44a733a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44a733a",
  null
  
)

export default component.exports